const map = {
    nationality: [
        {
            title: '编号',
            dataIndex: 'number',
        },
        {
            title: '名称',
            dataIndex: 'name',
        },
    ],
    role: [
        {
            title: '角色类型',
            dataIndex: 'number',
        },
        {
            title: '生效日期',
            dataIndex: 'name',
        },
    ],
    profession: [],
    post: [],
    employer: [],
    address: [],
};
export default map;
